import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import { withRouter } from 'react-router-dom';

import ExpandedMenu from './ExpandedMenu';
import MenuBar from './MenuBar';

class HeaderMenuBottom extends React.PureComponent {
    static propTypes = {
        onMouseOver: PropTypes.func.isRequired,
        onMouseLeave: PropTypes.func.isRequired,
        onFocus: PropTypes.func.isRequired,
        onBlur: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
        menus: PropTypes.arrayOf(PropTypes.object).isRequired,
        hoverActive: PropTypes.bool,
        hoverMenuId: PropTypes.string,
    };

    render() {
        const {
            menus,
            hoverActive,
            hoverMenuId,
            onFocus,
            onBlur,
            onClick,
            onMouseOver,
            onMouseLeave,
        } = this.props;

        return (
            <div onMouseLeave={onMouseLeave}>
                <Row id="header-bottom-menu-row" className="header-bottom-menu-row">
                    <Col>
                        <Container>
                            <Navbar className="header-bottom-nav p-0" expand="lg">
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                <Navbar.Collapse id="basic-navbar-nav">
                                    <MenuBar
                                        menus={menus}
                                        hoverActive={hoverActive}
                                        hoverMenuId={hoverMenuId}
                                        onMouseOver={onMouseOver}
                                        onFocus={onFocus}
                                        onClick={onClick}
                                    />
                                </Navbar.Collapse>
                            </Navbar>
                        </Container>
                    </Col>
                </Row>
                <ExpandedMenu
                    menus={menus}
                    hoverMenuId={hoverMenuId}
                    onClick={onClick}
                    onMouseLeave={onMouseLeave}
                    onFocus={onFocus}
                    onBlur={onBlur}
                />
            </div>
        );
    }
}

export default withRouter(HeaderMenuBottom);
